import React from "react";
import { Text, type TextProps } from "@chakra-ui/react";

export function Tab({ children, ...props }: TextProps) {
  return (
    <Text fontSize={{ base: "xs", lg: "sm", xl: "md" }} fontWeight="medium" pb={{ base: 2, lg: 3 }} px={1} {...props}>
      {children}
    </Text>
  );
}
